export default {
  startEndDateWarning: "End Date that is earlier than Start Date",
  outsideScenarioDatesWarning: "Outside Scenario Dates",
  performanceKpiSingleFlightHint: "Multiple flightings are not available for this Performance KPI.",
  campaignIdWarningHint: "Note: Campaign ID belongs to the exiting campaign.",
  campaignIdLockedHint: "Campaign ID can't be changed while the plan or any of its scenarios is approved.",
  calculateScoresConditionsTitle: "To calculate scores:",
  calculateScoresConditionSingleDma: "Exactly one DMA is targeted",
  calculateScoresConditionChannel: "Radio or Television channel is selected",
  calculateScoresConditionDemo: "Gender and Age Group are selected",
  calculateScoresConditionBudgets: "Every flight has a budget and date range",
  grpPerWeekScoreLabel: "GRP/week Score",
  viabilityScoreLabel: "Viability Score",
  marketViabilityScoreLabel: "Market Viability Score",
  bucketLabel: "Bucket",
  marketLabel: "Market",
  dmaCodeLabel: "DMA Code",
};
